export default class Routes {
  static questionnaireAttachmentPath = ({ projectId, controlId, controlTestId, id }) =>
    `/projects/${projectId}/controls/${controlId}/control_tests/${controlTestId}/exception_attachments/${id}/download`;
}
